import { useOrdersSizeParam } from "./OrdersSizeSelect";

export const useOrdersSizeLimit = (): number => {
  const [size] = useOrdersSizeParam();
  return Number(size) || Infinity;
};
